import { render, staticRenderFns } from "./LogoSignature4BrandsSection.vue?vue&type=template&id=81492898"
import script from "./LogoSignature4BrandsSection.vue?vue&type=script&lang=ts"
export * from "./LogoSignature4BrandsSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoSignature4BrandsSection.vue?vue&type=style&index=0&id=81492898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports